import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

type PageLanguage = 'en' | 'sc' | 'tc';

export const pageLanguageFromPath = (pathname: string): PageLanguage => {
  const segment = pathname.split('/')[1];
  return segment === 'sc' || segment === 'tc' ? segment : 'en';
};

export const localizedPageUrls = (pathname: string, pagePath: string, baseUrl: string) => {
  const language = pageLanguageFromPath(pathname);
  const base = baseUrl.replace(/\/$/, '');
  const url = (lang: PageLanguage) => `${base}/${lang}${pagePath}`;

  return {
    canonical: url(language),
    alternatives: [
      { language: 'en', hrefLang: 'en', href: url('en') },
      { language: 'sc', hrefLang: 'zh-Hans', href: url('sc') },
      { language: 'tc', hrefLang: 'zh-Hant', href: url('tc') },
    ],
  };
};

const LocalizedPageLinks = ({ pagePath }: { pagePath: string }) => {
  const { pathname } = useLocation();
  const links = localizedPageUrls(
    pathname,
    pagePath,
    process.env.REACT_APP_BASE_URL || window.location.origin
  );

  return (
    <Helmet>
      <link rel="canonical" href={links.canonical} />
      {links.alternatives.map((alternate) => (
        <link key={alternate.language} rel="alternate" href={alternate.href} hrefLang={alternate.hrefLang} />
      ))}
    </Helmet>
  );
};

export default LocalizedPageLinks;
